import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import LandingPage from "./camponents/LandingPage";
import Login from "./camponents/Login";

import Navbar from "./camponents/Navbar";
import { Toaster } from "react-hot-toast";

import Profile from "./camponents/Profile";
import Dashboard from "./camponents/Dashboard";
import LoadtruckItems from "./camponents/LoadtruckItems";
import LoadedItemSummary from "./camponents/LoadedItemSummary";
import Summary from "./camponents/Summary";
import { useEffect, useState } from "react";
import { requestForToken } from "./firebase";

// Improved PrivateRoute component with proper token validation
const PrivateRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation(); // Add this line to get the location

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem("ambikaDriverToken");
      const userId = localStorage.getItem("ambikaDriverId");

      // Basic check - you can add API validation here if needed
      if (token && userId) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem("ambikaDriverToken");
        localStorage.removeItem("ambikaDriverId");
      }
      setIsValidating(false);
    };

    validateToken();
  }, []);

  if (isValidating) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/log-in" replace state={{ from: location }} />
  );
};

const AuthCheck = ({ children }) => {
  const token = localStorage.getItem("ambikaDriverToken");
  const userId = localStorage.getItem("ambikaDriverId");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (token && userId) {
      const from = location.state?.from?.pathname || "/dashboard";
      navigate(from, { replace: true });
    }
  }, [token, userId, navigate, location]);

  if (token && userId) {
    return null;
  }
  return children;
};
function App() {
  const location = useLocation();
  const isActiveLink = (link) => {
    // console.log(location.pathname);
    return link === location.pathname;
  };

  const token = localStorage.getItem("ambikaDriverToken");
  const userId = localStorage.getItem("ambikaDriverId");

  useEffect(() => {
    if (!userId || !token) return;

    if (!("Notification" in window)) {
      console.warn("🚫 Notifications are not supported in this browser.");
      return;
    }

    if ("Notification" in window) {
      if (Notification.permission !== "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            requestForToken(userId, token);
          } else {
            console.warn("🚫 Notification denied by user");
          }
        });
      }
    }
  }, [userId, token]);

  return (
    <div className="App">
      <Toaster position="top-right" />
      {isActiveLink("/") || isActiveLink("/log-in") ? "" : <Navbar />}
      <div style={{ height: "70px" }}></div>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/log-in"
          element={
            <AuthCheck>
              <Login />
            </AuthCheck>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/load-truck-items"
          element={
            <PrivateRoute>
              <LoadtruckItems />
            </PrivateRoute>
          }
        />

        <Route
          path="/loaded-item-summarys"
          element={
            <PrivateRoute>
              <LoadedItemSummary />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />

        {/* <Route path='/load-truck-summary' element={<PrivateRoute><Summary /></PrivateRoute>} /> */}
      </Routes>
    </div>
  );
}

export default App;
